import React, { useState } from 'react'
import { EditorState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import { useFormik } from 'formik'
import { useNavigate } from 'react-router-dom'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

import HeaderScheda from '../components/scheda/HeaderScheda'
import ContenutoScheda from '../components/scheda/ContenutoScheda'
import MetaScheda from '../components/scheda/MetaScheda'
import creazione from '../api/creazione'
import BottoniScheda from '../components/scheda/BottoniScheda'
import FormAttrazione from '../components/form/FormAttrazione'
import useStagionalita from '../controllers/generale/useStagionalita'
import useLocalita from '../controllers/generale/useLocalita'
import useAttrazione from '../controllers/esperienze/useAttrazioni'
import useStrutture from '../controllers/campeggi/useStrutture'
import useEsperienze from '../controllers/esperienze/useEsperienze'
import useGenerale from '../controllers/generale/useGenerale'
import SceltaStagionalita from '../components/scheda/SceltaStagionalita'
import SceltaLocalita from '../components/scheda/SceltaLocalita'
import utils from '../utils/utils'
import submitFormikWithValidationToast from '../utils/submitFormikWithValidationToast'
import validators from '../utils/validators'
import defaultValues from '../utils/defaultValues'
import { buildResourceData } from '../utils/resourceData'
import SceltaStrutture from '../components/scheda/SceltaStrutture'
import useSchedaCopiata from '../controllers/schedaCopiata/useSchedaCopiata'
import SceltaLogo from '../components/scheda/SceltaLogo'
import upload from '../api/upload'
import SceltaCategorie from '../components/scheda/SceltaCategorie'
import SceltaTematiche from '../components/scheda/SceltaTematiche'
import FAQScheda from '../components/scheda/FAQScheda'
import useFaqSectionState from '../hooks/useFaqSectionState'
import { persistPolymorphicFaq } from '../utils/faqPersist'

function CreaAttrazione(props) {
  const navigate = useNavigate()
  const { stagioni, meteo } = useStagionalita()
  const { categorieEsperienza, macroCategorie } = useEsperienze()
  const { localita } = useLocalita()
  const { strutture } = useStrutture()
  const { addAttrazione, importanzaMaxAttrazioni } = useAttrazione()
  const { tematiche } = useGenerale()
  const { schedaCopiata, copiaScheda } = useSchedaCopiata()

  const [openAlert, setOpenAlert] = useState(0)
  const [situazione, setSituazione] = useState(1)
  const [lingua, setLingua] = useState(1) //1 italiano, ...
  const [loading, setLoading] = useState(false)
  const [errore, setErrore] = useState()
  const [altro, setAltro] = useState({
    stagioni: new Array(stagioni.length).fill(false),
    meteo: new Array(meteo.length).fill(false),
    localita: new Array(localita.length).fill(false),
    strutture: new Array(strutture.length).fill(false),
    tematiche: new Array(tematiche.length).fill(false),
    categorie: [],
  })
  const [contenuto, setContenuto] = useState({
    italiano: EditorState.createEmpty(),
    inglese: EditorState.createEmpty(),
    tedesco: EditorState.createEmpty(),
    olandese: EditorState.createEmpty(),
    danese: EditorState.createEmpty(),
    polacco: EditorState.createEmpty(),
  })
  const [titolo, setTitolo] = useState({
    italiano: '',
    inglese: '',
    tedesco: '',
    olandese: '',
    danese: '',
    polacco: '',
  })
  const [valoriMeta, setValoriMeta] = useState({
    italiano: '',
    inglese: '',
    tedesco: '',
    olandese: '',
    danese: '',
    polacco: '',
  })
  const [valoriMetaTitle, setValoriMetaTitle] = useState({
    italiano: '',
    inglese: '',
    tedesco: '',
    olandese: '',
    danese: '',
    polacco: '',
  })
  const {
    faqAbilitato,
    faqList,
    applyFromApi,
    loadFromCopia,
    cambiaFaqAbilitato,
    cambiaFaqItem,
    aggiungiFaqItem,
    rimuoviFaqItem,
    trimFaqListToLength,
  } = useFaqSectionState()
  const [logo, setLogo] = useState({ preview: null, file: null })

  const formik = useFormik({
    validationSchema: validators.attrazione,
    initialValues: defaultValues.attrazione,
    onSubmit: async (v) => {
      if (!titolo.italiano?.length) return setErrore('Inserire il nome in Italiano.')
      setLoading(true)
      let values = { ...v }
      let results
      //aggiungo importanza
      values.importanza = importanzaMaxAttrazioni()
      //aggiungo i titoli
      values.nome_italiano = titolo.italiano
      values.nome_inglese = titolo.inglese
      values.nome_tedesco = titolo.tedesco
      values.nome_olandese = titolo.olandese
      values.nome_danese = titolo.danese
      values.nome_polacco = titolo.polacco
      //aggiungo le descrizioni
      values.descrizione_italiano = draftToHtml(convertToRaw(contenuto.italiano.getCurrentContent()))
      values.descrizione_inglese = draftToHtml(convertToRaw(contenuto.inglese.getCurrentContent()))
      values.descrizione_tedesco = draftToHtml(convertToRaw(contenuto.tedesco.getCurrentContent()))
      values.descrizione_olandese = draftToHtml(convertToRaw(contenuto.olandese.getCurrentContent()))
      values.descrizione_danese = draftToHtml(convertToRaw(contenuto.danese.getCurrentContent()))
      values.descrizione_polacco = contenuto.polacco
        ? draftToHtml(convertToRaw(contenuto.polacco.getCurrentContent()))
        : ''
      //aggiungo i meta tag
      values.meta_italiano = valoriMeta.italiano
      values.meta_inglese = valoriMeta.inglese
      values.meta_tedesco = valoriMeta.tedesco
      values.meta_olandese = valoriMeta.olandese
      values.meta_danese = valoriMeta.danese
      values.meta_polacco = valoriMeta.polacco
      values.meta_title_italiano = valoriMetaTitle.italiano || ''
      values.meta_title_inglese = valoriMetaTitle.inglese || ''
      values.meta_title_tedesco = valoriMetaTitle.tedesco || ''
      values.meta_title_olandese = valoriMetaTitle.olandese || ''
      values.meta_title_danese = valoriMetaTitle.danese || ''
      values.meta_title_polacco = valoriMetaTitle.polacco || ''
      //controllo lat e long
      values.latitudine = parseFloat(values.latitudine) ? parseFloat(values.latitudine) : null
      values.longitudine = parseFloat(values.longitudine) ? parseFloat(values.longitudine) : null
      //creo il logo
      if (logo.file) {
        let formData = new FormData()
        formData.append('immagine', logo.file, logo.file.name)
        results = await upload.creaImmagine(formData)
        if (!results.ok) {
          setLoading(false)
          return setErrore(results.data)
        }
        values.logo = results.data.link
      }
      //creo l'oggetto
      results = await creazione.creaAttrazione(
        values,
        utils.componiLista(stagioni, altro.stagioni),
        utils.componiLista(meteo, altro.meteo),
        utils.componiLista(localita, altro.localita),
        utils.componiLista(strutture, altro.strutture),
        utils.componiLista(tematiche, altro.tematiche),
        altro.categorie
      )
      if (!results.ok) {
        setErrore(results.data)
        return setLoading(false)
      }
      if (results.data?.id) {
        const faqResults = await persistPolymorphicFaq({
          parentType: 'attrazione',
          parentId: results.data.id,
          faqAbilitato,
          faqList,
        })
        if (!faqResults.ok) {
          const errMsg =
            typeof faqResults.data === 'string' ? faqResults.data : faqResults.data?.message || faqResults.data
          setErrore(errMsg)
          setLoading(false)
          return
        }
        const faqData = faqResults.data
        if (faqData) {
          applyFromApi(faqData)
        }
      }
      //aggiungo l'oggetto al context
      addAttrazione(results.data)
      //manda indietro
      setTimeout(() => {
        setLoading(false)
        navigate('..', { replace: true, state: { nuovaAttrazione: results.data } })
      }, 500)
    },
  })

  const confermaFormikValidato = () => submitFormikWithValidationToast(formik, setErrore)

  const cambiaTitolo = (event) => {
    const data = event.target.value
    const appo = { ...titolo }
    if (lingua == 1) {
      appo.italiano = data
      return setTitolo(appo)
    } else if (lingua == 2) {
      appo.inglese = data
      return setTitolo(appo)
    } else if (lingua == 3) {
      appo.tedesco = data
      return setTitolo(appo)
    } else if (lingua == 4) {
      appo.olandese = data
      return setTitolo(appo)
    } else if (lingua == 5) {
      appo.danese = data
      return setTitolo(appo)
    } else {
      appo.polacco = data
      return setTitolo(appo)
    }
  }

  const cambiaValoriMeta = (event) => {
    const data = event.target.value
    const appo = { ...valoriMeta }
    if (lingua == 1) {
      appo.italiano = data
      return setValoriMeta(appo)
    } else if (lingua == 2) {
      appo.inglese = data
      return setValoriMeta(appo)
    } else if (lingua == 3) {
      appo.tedesco = data
      return setValoriMeta(appo)
    } else if (lingua == 4) {
      appo.olandese = data
      return setValoriMeta(appo)
    } else if (lingua == 5) {
      appo.danese = data
      return setValoriMeta(appo)
    } else {
      appo.polacco = data
      return setValoriMeta(appo)
    }
  }

  const cambiaValoriMetaTitle = (event) => {
    const data = event.target.value
    const appo = { ...valoriMetaTitle }
    if (lingua == 1) {
      appo.italiano = data
      return setValoriMetaTitle(appo)
    } else if (lingua == 2) {
      appo.inglese = data
      return setValoriMetaTitle(appo)
    } else if (lingua == 3) {
      appo.tedesco = data
      return setValoriMetaTitle(appo)
    } else if (lingua == 4) {
      appo.olandese = data
      return setValoriMetaTitle(appo)
    } else if (lingua == 5) {
      appo.danese = data
      return setValoriMetaTitle(appo)
    } else {
      appo.polacco = data
      return setValoriMetaTitle(appo)
    }
  }

  const cambiaContenuto = (newState) => {
    const appo = { ...contenuto }
    if (lingua == 1) {
      appo.italiano = newState
      return setContenuto(appo)
    } else if (lingua == 2) {
      appo.inglese = newState
      return setContenuto(appo)
    } else if (lingua == 3) {
      appo.tedesco = newState
      return setContenuto(appo)
    } else if (lingua == 4) {
      appo.olandese = newState
      return setContenuto(appo)
    } else if (lingua == 5) {
      appo.danese = newState
      return setContenuto(appo)
    } else {
      appo.polacco = newState
      return setContenuto(appo)
    }
  }

  const copiaContenuti = (appoTitolo, appoContenuto) => {
    setTitolo(appoTitolo)
    setContenuto(appoContenuto)
    setOpenAlert(4)
  }

  const cambiaStagione = (position) => {
    const appo = { ...altro }
    const nuovo = altro.stagioni.map((item, index) => (index === position ? !item : item))
    appo.stagioni = nuovo
    setAltro(appo)
  }

  const cambiaMeteo = (position) => {
    const appo = { ...altro }
    const nuovo = altro.meteo.map((item, index) => (index === position ? !item : item))
    appo.meteo = nuovo
    setAltro(appo)
  }

  const cambiaLocalita = (position) => {
    const appo = { ...altro }
    const nuovo = altro.localita.map((item, index) => (index === position ? !item : item))
    appo.localita = nuovo
    setAltro(appo)
  }

  const cambiaStruttura = (position) => {
    const appo = { ...altro }
    const nuovo = altro.strutture.map((item, index) => (index === position ? !item : item))
    appo.strutture = nuovo
    setAltro(appo)
  }

  const cambiaCategoria = (id) => {
    const appo = { ...altro }
    const trovato = altro.categorie.filter((c) => c == id)[0]
    if (trovato) {
      appo.categorie = appo.categorie.filter((c) => c != id)
    } else {
      appo.categorie.push(id)
    }
    setAltro(appo)
  }

  const cambiaTematica = (position) => {
    const appo = { ...altro }
    const nuovo = altro.tematiche.map((item, index) => (index === position ? !item : item))
    appo.tematiche = nuovo
    setAltro(appo)
  }

  const doIncollaSchedaCopiata = () => {
    //cambio il form
    const values = utils.incollaElementi(formik.values, schedaCopiata.values)
    formik.setValues(values)
    //cambio il titolo
    setTitolo(schedaCopiata.titolo)
    //cambio il contenuto
    setContenuto(schedaCopiata.contenuto)
    //cambio altro
    setAltro(utils.incollaElementi(altro, schedaCopiata.altro))
    //meta e FAQ
    if (schedaCopiata.valoriMeta) setValoriMeta(schedaCopiata.valoriMeta)
    if (schedaCopiata.valoriMetaTitle) setValoriMetaTitle(schedaCopiata.valoriMetaTitle)
    loadFromCopia(schedaCopiata)
    //alert success
    setOpenAlert(5)
    copiaScheda()
  }

  const caricaLogo = async (event) => {
    const file = event.target.files[0]
    //controllo che sia immagine
    if (file.type.split('/')[0] != 'image') return setErrore('Formato del file non valido. Richiesta Immagine.')
    //creo l'immagine
    const preview = URL.createObjectURL(file)
    setLogo({ file: file, preview: preview })
  }

  const pulisciLogo = () => setLogo({ file: null, preview: null })

  const chiudiAlert = (event, reason) => {
    if (reason === 'clickaway') return
    setErrore()
    setOpenAlert(0)
  }

  return (
    <React.Fragment>
      <HeaderScheda
        titolo={'NUOVA ATTRAZIONE'}
        elementi={[
          'form',
          'contenuti',
          'stagionalita',
          'localita',
          'strutture',
          'tematiche',
          'categorie',
          'seo',
          'faq',
        ]}
        situazione={situazione}
        cambiaSituazione={(v) => setSituazione(v)}
        nome={titolo.italiano.length > 0 ? titolo.italiano : null}
        schedaCopiata={schedaCopiata}
        doIncollaSchedaCopiata={doIncollaSchedaCopiata}
        loading={loading}
        modifiche={true}
        conferma={confermaFormikValidato}
        annulla={() => navigate(-1)}
        viewPageSection="attrazioni"
      ></HeaderScheda>

      {situazione == 1 && (
        <>
          {/* <SceltaLogo
                    logo={logo}
                    caricaLogo={caricaLogo}
                    pulisciLogo={pulisciLogo}
                ></SceltaLogo> */}
          <FormAttrazione
            values={formik.values}
            errors={formik.errors}
            touched={formik.touched}
            handleChange={formik.handleChange}
            setFieldValue={formik.setFieldValue}
          ></FormAttrazione>
        </>
      )}
      {situazione == 2 && (
        <ContenutoScheda
          lingua={lingua}
          cambiaLingua={(v) => setLingua(v)}
          titolo={titolo}
          cambiaTitolo={cambiaTitolo}
          contenuto={contenuto}
          cambiaContenuto={cambiaContenuto}
          copiaContenuti={copiaContenuti}
          valoriMeta={valoriMeta}
          cambiaValoriMeta={cambiaValoriMeta}
        ></ContenutoScheda>
      )}
      {situazione == 20 && (
        <MetaScheda
          lingua={lingua}
          cambiaLingua={(v) => setLingua(v)}
          valoriMeta={valoriMeta}
          cambiaValoriMeta={cambiaValoriMeta}
          valoriMetaTitle={valoriMetaTitle}
          cambiaValoriMetaTitle={cambiaValoriMetaTitle}
          isModifica={false}
          resourceData={buildResourceData(
            'attrazione',
            titolo,
            (() => {
              try {
                return draftToHtml(convertToRaw(contenuto.italiano.getCurrentContent()))
              } catch {
                return ''
              }
            })()
          )}
        />
      )}
      {situazione == 21 && (
        <FAQScheda
          lingua={lingua}
          cambiaLingua={(v) => setLingua(v)}
          faqAbilitato={faqAbilitato}
          cambiaFaqAbilitato={cambiaFaqAbilitato}
          faqList={faqList}
          cambiaFaqItem={cambiaFaqItem}
          aggiungiFaqItem={aggiungiFaqItem}
          rimuoviFaqItem={rimuoviFaqItem}
                trimFaqListToLength={trimFaqListToLength}
          titolo={titolo}
          contenuto={contenuto}
          isModifica={false}
        />
      )}
      {situazione == 3 && (
        <SceltaStagionalita
          meteo={meteo}
          stagioni={stagioni}
          stagioniSel={altro.stagioni}
          meteoSel={altro.meteo}
          cambiaStagione={cambiaStagione}
          cambiaMeteo={cambiaMeteo}
        ></SceltaStagionalita>
      )}
      {situazione == 4 && (
        <SceltaLocalita listaSel={altro.localita} localita={localita} cambiaLocalita={cambiaLocalita}></SceltaLocalita>
      )}
      {situazione == 5 && (
        <SceltaStrutture
          strutture={strutture}
          struttureSelezionate={altro.strutture}
          cambiaStruttura={cambiaStruttura}
        ></SceltaStrutture>
      )}
      {situazione == 13 && (
        <SceltaTematiche
          tematiche={tematiche}
          listaSel={altro.tematiche}
          cambiaTematica={cambiaTematica}
        ></SceltaTematiche>
      )}
      {situazione == 14 && (
        <SceltaCategorie
          macro={macroCategorie}
          categorie={categorieEsperienza}
          listaSel={altro.categorie}
          cambiaCategoria={cambiaCategoria}
        ></SceltaCategorie>
      )}
      <BottoniScheda loading={loading} conferma={confermaFormikValidato} annulla={() => navigate(-1)}></BottoniScheda>

      <Snackbar
        open={openAlert == 4}
        onClose={chiudiAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ top: 70 }}
      >
        <Alert onClose={chiudiAlert} variant="filled" severity="success" sx={{ width: '100%' }}>
          Contenuti copiati nelle diverse linue.
        </Alert>
      </Snackbar>
      <Snackbar
        open={openAlert == 5}
        onClose={chiudiAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ top: 70 }}
      >
        <Alert onClose={chiudiAlert} variant="filled" severity="success" sx={{ width: '100%' }}>
          Scheda Incollata.
        </Alert>
      </Snackbar>
      <Snackbar
        open={errore?.length > 0}
        onClose={chiudiAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ top: 70 }}
      >
        <Alert onClose={chiudiAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
          {errore}
        </Alert>
      </Snackbar>
    </React.Fragment>
  )
}

export default CreaAttrazione
